import {useEffect} from 'react';
import {getUserId} from '@Libraries/user.library';
import {getRemoveBackgroundCost, REMOVED_BG_IMAGE_COST} from '@Utils/image.util';
import {setImageBgRemovalCreditsCost} from '@Components/image-bg-removal-credits-cost/image-bg-removal-credits-cost-slice';
import {useAppDispatch, useAppSelector} from '@/hooks';

const ongoingRequests = new Set<string>();

export function useGetRemoveImageBackgroundCreditsCost(imageSource: string, hashedFilename?: string): number | null {
  const userId = getUserId();

  const dispatch = useAppDispatch();
  const backgroundRemovalCreditsCost = useAppSelector((state) => {
    return hashedFilename ? state.imageBgRemovalCreditsCost[hashedFilename] : REMOVED_BG_IMAGE_COST;
  });

  useEffect((): void => {
    if (!hashedFilename) {
      return;
    }
    if (backgroundRemovalCreditsCost !== null) {
      return;
    }

    if (ongoingRequests.has(hashedFilename)) {
      return;
    }

    ongoingRequests.add(hashedFilename);

    void getRemoveBackgroundCost(hashedFilename, imageSource)
      .then((credits) => {
        dispatch(
          setImageBgRemovalCreditsCost({
            imageKey: hashedFilename,
            credits,
          })
        );
      })
      .finally(() => {
        ongoingRequests.delete(hashedFilename);
      });
  });

  if (!userId) {
    return null;
  }

  return backgroundRemovalCreditsCost;
}
